import { Box, useDisclosure } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
} from '@televet/kibble-ui/build/components/Modal';
import { TextInput } from '@televet/kibble-ui/build/components/TextInput';
import React, { useCallback } from 'react';

type EmailModalPreviewProps = {
  html: string;
  onSendTestEmail: () => void;
  testEmail: string;
  changeTestEmail: (email: string) => void;
};

const EmailModalPreview = ({
  html,
  testEmail,
  changeTestEmail,
  onSendTestEmail,
}: EmailModalPreviewProps): JSX.Element => {
  const { onOpen, onClose, isOpen } = useDisclosure();

  const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
  const doctypeRegex = /<!DOCTYPE[^>]*>/gi;
  const htmlRegex = /<html[^>]*>/gi;
  const htmlCloseRegex = /<\/html>/gi;
  const headRegex = /<head[^>]*>/gi;
  const headCloseRegex = /<\/head>/gi;
  const bodyRegex = /<body[^>]*>/gi;
  const bodyCloseRegex = /<\/body>/gi;

  const sanitizedHtml = html
    .replaceAll(scriptRegex, '')
    .replaceAll(doctypeRegex, '')
    .replaceAll(htmlRegex, '')
    .replaceAll(htmlCloseRegex, '')
    .replaceAll(headRegex, '')
    .replaceAll(headCloseRegex, '')
    .replaceAll(bodyRegex, '')
    .replaceAll(bodyCloseRegex, '');
  const sendTestEmail = useCallback((): void => {
    onSendTestEmail();
    onClose();
  }, [onSendTestEmail, onClose]);
  return (
    <>
      <Button mt="4" variant="tertiary" onClick={onOpen}>
        Preview
      </Button>
      <Modal allowEscape isOpen={isOpen} onClose={onClose} size="3xl" autoFocus>
        <ModalHeader>Email Preview</ModalHeader>
        <ModalCloseButton />
        <ModalBody maxHeight="80vh" overflow="scroll">
          <Box width="100%" dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
        </ModalBody>
        <ModalFooter>
          <TextInput
            value={testEmail || ''}
            onChange={(e): void => changeTestEmail(e.target.value)}
            placeholder="Enter email address"
          />
          <Button variant="secondarySubtle" ml={4} paddingLeft={8} paddingRight={8} onClick={sendTestEmail}>
            Send Test Email
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default EmailModalPreview;
